import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'isp-field-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./scss/hint.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldHintComponent {
  @Input() hintMsg: string;

  @Input() hintAttachContainer: string;

  @Input() visible: boolean;

  @ViewChild('tooltip') tooltip: ElementRef<HTMLIspuiTooltipElement>;

  toggle(state: boolean): void {
    this.tooltip?.nativeElement.toggle(state);
  }
}
